import useSearch from '~/services/loop54/hooks/useSearch';
import { SearchRequest } from '~/services/loop54/types';

export default function useSearchResults(params: SearchRequest) {
    return useSearch(params);
}
